import { Box } from '@mui/material';

const ImageCard = ({ src, alt, height,objectPosition = 'center' }) => (
  <Box
    component="img"
    src={src}
    alt={alt}
    alignItems={"center"}
    sx={{
      width: "100%",
      height: height || "auto",
      maxWidth: "100vw",
      borderRadius: 2,
      boxShadow: 3,
      m: { xs: 0, sm: 0.5 },
      objectFit: height ? "cover" : "contain",  // ✅ crop when height is set, scale otherwise
      objectPosition: height ? objectPosition : "center",  // ✅ only applies when cropping
    }}
  />
);

export default ImageCard;